import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import type { ChapterEnum, SectionEnum } from 'gql/graphql';
import { WorkOrderSummaryItem } from 'pages/Project/UerProject/WorkOrder/WorkOrderSummary/WorkOrderSummaryItem';
import { Button, IconRestart, Loader } from 'uikit';

import type React from 'react';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { workOrderChangeObjectResultGql } from '../WorkOrderChangeQueries';

import Styles from './WorkOrderChangeSummary.module.css';

interface IWorkOrderChangeSummary {
    chapter?: ChapterEnum | null;
    section?: SectionEnum;
    workOrderChangeObjectId: number;
    isVisible: boolean;
    costRounding: number;
    workOrderChangeId: number;
    workOrderObjectId: number | undefined;
}

export const WorkOrderChangeSummary: React.FC<IWorkOrderChangeSummary> = (props) => {
    const { chapter, section, workOrderChangeObjectId, isVisible, costRounding, workOrderChangeId, workOrderObjectId } =
        props;
    const dispatch = useDispatch();

    const [
        workOrderChangeObjectResultData,
        workOrderChangeObjectResultStatus,
        ,
        workOrderChangeObjectResultMakeRequest,
    ] = useRequest({
        requestId: 'workOrderChangeObjectResult',
        query: workOrderChangeObjectResultGql,
        withEffect: false,
    });

    const isLoading = workOrderChangeObjectResultStatus === RequestStatus.FETCHING;

    const onDataRefreshRequest = useCallback(() => {
        dispatch(
            workOrderChangeObjectResultMakeRequest({
                workOrderChangeObjectId,
                chapter,
                section,
                workOrderChangeId,
                workOrderObjectId,
            }),
        );
    }, [
        chapter,
        dispatch,
        section,
        workOrderChangeId,
        workOrderChangeObjectId,
        workOrderChangeObjectResultMakeRequest,
        workOrderObjectId,
    ]);

    useEffect(() => {
        if (isVisible) {
            onDataRefreshRequest();
        }
    }, [isVisible, onDataRefreshRequest]);

    return (
        <div className={Styles.workOrderChangeSummaryContainer}>
            <div className={Styles.workOrderChangeSummaryHeader}>
                <div>Итоги Главы</div>
                <Button
                    iconLeft={IconRestart}
                    disabled={isLoading}
                    view="secondary"
                    onClick={onDataRefreshRequest}
                    size="s"
                />
            </div>
            <div className={Styles.workOrderChangeSummaryContent}>
                {isLoading && <Loader className={Styles.workOrderChangeSummaryLoader} />}
                {!isLoading &&
                    workOrderChangeObjectResultData?.uerWorkOrderChangeObjectResult?.map((item, index) => (
                        <WorkOrderSummaryItem costRounding={costRounding} item={item} key={index} />
                    ))}
            </div>
        </div>
    );
};

WorkOrderChangeSummary.displayName = 'WorkOrderChangeSummary';
